import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  danhSachVanBanDen: [],
  danhSachHienThiCotVanBanDen: [],
  danhSachHienThiCotVanBanDenCapNhat: [],
  danhSachTatCaTrangThai: [],
  danhSachDonViThuHoi: [],
  nguoiBiTraLai: [],
  danhSachLoaiVanBan: [],
  danhSachSoVanBan: [],
  danhSachPhuongThucNhan: [],
  danhSachLoaiVanBanChuaVaoSo: [],
  danhSachDoKhan: [],
  danhSachDonViNgoai: [],
  danhSachDonViNgoaiKhongLienThong: [],
  danhSachOptionDonVi: [],
  chiTietVanBanDen: [],
  danhSachFileVanBanDen: [],
  danhSachXemLuongPhanXuLy: [],
  danhSachYKienVanBan: [],
  danhSachCanBoXinYKien: [],
  danhSachLanhDaoDonVi: [],
  danhSachNhomLamViec: [],
  dataFilterDashboard: null,
  danhSachDonViCaNhanPXL: [],
  danhSachSoByDonVi :[],
  pageIndex: {
    Size: 10,
    Index: 1,
  },
  keepAlivePage: false,
  dateFilterTable: null
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
